const _state = {
  selectedSession: null,
  isRenderedReport: true,
  isCreatingNewSession: false,
}

export default _state
